import { Tab, Tabs } from '@material-ui/core';
import * as React from 'react';
import { PageBadge } from '../../models/utilities/page-badge';
import './PageComponent.scss';

// #region Component Props 

interface IProps {
    // What the page is called, when the top bar does not say so already: the page of a link of the menu has no title, as the
    // top bar has its name, while a page about one thing (a truck, a dealer), or one that is not in the menu, has one
    title?          : any;
    children?       : any;
    badges?         : PageBadge[];
    // Back Button
    showBackBtn?    : any;
    onBackClick?    : any;
    // Tabs
    useTabs?        : boolean;
    tabLabels?      : any[];
    selectedTab?    : number;
    onTabChange?    : any;
    shouldStick?    : boolean;
}

// #endregion

const PageHeading : React.SFC<IProps> = (props) => {

    const { 
        title, 
        children, 
        badges, 
        useTabs, 
        selectedTab, 
        onTabChange, 
        tabLabels,
        shouldStick 
    } = props;

    const hasTitle = title !== undefined && title !== null && title !== false && title !== '';
    const hasActions = React.Children.count(children) > 0;

    // Without a title there is a bar for the buttons of the page, and no bar when there are none
    if (!useTabs && !hasTitle && !props.showBackBtn) {
        return hasActions
            ? <div className={"row align-items-center justify-content-end page-heading actions-only " + (shouldStick ? 'make-sticky' : '')}>
                <div className="col-auto">
                    <div className="page-actions">
                        { children }
                    </div>
                </div>
            </div>
            : null;
    }

    return <div className={"row align-items-center page-heading " + (useTabs ? 'with-tabs' : '') + (shouldStick ? 'make-sticky' : '')}>
                <div className="col">
                {
                    !useTabs  
                    ? <h1 className="page-heading-h1">
                        {
                            props.showBackBtn
                                ? <button 
                                    onClick={ props.onBackClick }
                                    className="heading-back-btn">
                                        <i className="la la-arrow-circle-o-left"/>
                                </button>
                                : null
                        }
                        { title }
                        {
                            badges && badges.length > 0 ?
                            badges.map((b : PageBadge) => (
                                <span key={b.text} className={ `badge badge-secondary ${ b.state }` }>{ b.text }</span>
                            )) : null
                        }
                    </h1> 
                    : <Tabs 
                        classes={{ 
                            root: 'page-tabs', 
                            indicator: 'page-tab-indicator' 
                        }}
                        value={ selectedTab } 
                        onChange={ onTabChange }>
                        {
                            tabLabels ? tabLabels.map((itm: string, idx: number ) => (
                                <Tab    
                                    key={idx}                            
                                    classes={{ 
                                        root: 'page-tab', 
                                        selected: 'page-tab-selected'
                                    }}
                                    label={ 
                                        <h1>{ itm }</h1> 
                                    } />
                            )) : null
                        }
                    </Tabs>    
                }
                </div>
                {
                    children ? 
                    <div className="col-md-auto">
                        <div className="page-actions">
                            { children }
                        </div>
                    </div> : null
                }                
            </div>;
};

PageHeading.defaultProps = {
    children        : [],
    badges          : [] as PageBadge[],
    useTabs         : false,
    showBackBtn     : false,
    onBackClick     : () => { return; },
    tabLabels       : [] as string[],
    selectedTab     : 0,
    onTabChange     : (p1: any, p2: any) => { return; },
    shouldStick     : false
};

export { PageHeading };
